import React from 'react';

const PublicPlaylistVideoPage = () => {
  return <div>PublicPlaylistVideo</div>;
};

export default PublicPlaylistVideoPage;
